import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchOAuthCode = createAction(constants.FETCH_OAUTH_CODE)
export const fetchOAuthCodePending = createAction(constants.FETCH_OAUTH_CODE_PENDING)
export const fetchOAuthCodeFailed = createAction(constants.FETCH_OAUTH_CODE_FAILED)
export const fetchOAuthCodeSuccess = createAction(constants.FETCH_OAUTH_CODE_SUCCESS)

export const fetchOAuthAppInfo = createAction(constants.FETCH_OAUTH_APP_INFO)
export const fetchOAuthAppInfoSuccess = createAction(constants.FETCH_OAUTH_APP_INFO_SUCCESS)
export const fetchOAuthAppInfoFailed = createAction(constants.FETCH_OAUTH_APP_INFO_FAILED)
export const fetchOAuthAppInfoPending = createAction(constants.FETCH_OAUTH_APP_INFO_PENDING)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/externalApp/actions.js